'use strict';

var _ = require('lodash');
var FBCsFilterByFBGFactory = function FBCsFilterByFBGFactory(DataFilter) {
  function FBCsFilterByFBG() {
    DataFilter.call(this, 'fares-mode', 'fbgs-grid', 1);
  }
  FBCsFilterByFBG.prototype = Object.create(DataFilter.prototype);
  FBCsFilterByFBG.prototype.filter = function (data, range) {
    range = range[0];
    var fareBasisGroups = range.fareBasisGroups;
    return _.filter(data, function (fbc) {
      return _.includes(fareBasisGroups, fbc.fareBasisGroup + ':' + fbc.className);
    });
  };
  return FBCsFilterByFBG;
};
FBCsFilterByFBGFactory.$inject = ['DataFilterFactory'];
module.exports = FBCsFilterByFBGFactory;